import React, { useContext, useEffect } from 'react';

import GLOBAL from "../../../global";
import CONSTANT from "../../../constants/Constant";
import Chatbot from "./Chatbot";
import NewChatbot from "./NewChatbot";
import { USE_NEW_CHATBOT } from "../../../constants/FeatureFlags";

import { isEmptyObject } from "../../../utils/Utils";
import { createBotOption, intakeOptions, mskOptions, postureOptions } from "./business/createBotInfoObj";
import { setBotInfo } from "../../../features/chat/chatbotSlice";
import { useDispatch, useSelector } from "react-redux";
import AppContext from "../../../contexts/AppContext";


const ChatBotWrapper = () => {
    const dispatch = useDispatch();
    const { userInfo } = useContext(AppContext);
    const { IsAthleteEnabled } = userInfo.Permissions;

    const botState = useSelector(state => state.chatBot);
    const chatBotUIState = botState?.chatBotUIState || false;
    const botData = botState?.botData || {};

    const selectedBotInfoObj = botData?.botInfo || {};
    const initChatBot = chatBotUIState?.initChatBot || false;
    const bodyRegionList = botData?.bodyRegionList || [];
    let invitationTypeName = (botData?.invitationTypeName || '').toLowerCase();

    useEffect(() => {
        if (initChatBot && !USE_NEW_CHATBOT) {
            dispatch(setBotInfo(getBotInfo()));
        }
    }, [initChatBot]);

    const getBotInfo = () => {
        GLOBAL.SHOULDER_TO_SHOULDER_DISTANCE = '';
        let botOption = {};

        if (invitationTypeName) {
            if (bodyRegionList.includes(CONSTANT.BODY_REGIONS.POSTURE.key)) {
                botOption = createBotOption(postureOptions, { IsAthleteEnabled: IsAthleteEnabled });
            } else if (invitationTypeName === CONSTANT.REDIRECT_TYPE.SELF) {
                botOption = createBotOption(mskOptions, { IsAthleteEnabled: IsAthleteEnabled });
            } else if (invitationTypeName === CONSTANT.REDIRECT_TYPE.TELEMEDICINE || invitationTypeName === CONSTANT.REDIRECT_TYPE.INCLINIC) {
                botOption = createBotOption(intakeOptions, { IsAthleteEnabled: IsAthleteEnabled });
            }
        }

        return botOption;
    };

    return (
        <>
            {USE_NEW_CHATBOT && initChatBot && (
                <NewChatbot />
            )}

            {!USE_NEW_CHATBOT && initChatBot && !isEmptyObject(selectedBotInfoObj) && (
                <Chatbot />
            )}
        </>
    );
};

export default ChatBotWrapper;
